import { useCallback } from "react";
import { Container, makeStyles } from "@material-ui/core";
import InfiniteScroll from "react-infinite-scroll-component";
import { useSelector } from "react-redux";
import { CircularProggressIndicator } from "../components-atoms/CircularProggressIndicator";
import { LoadMoreIndicator } from "../components-atoms/LoadMoreIndicator";
import { OrderItem } from "../components-molecules";
import { NoResultsFound } from "../components-molecules/NoResultsFound";
import { IOrderItemSource } from "../components-molecules/OrderItem";

export const OpenOrders = (props: any) => {
  const classes = useStyles();
  const pendingOrdersLoading = useSelector(
    (state: any) => state.pendingOrders.loading
  );
  const pendingOrdersData = useSelector(
    (state: any) => state.pendingOrders.data
  );

  const getDataLength = useCallback(() => {
    let count = 0;
    count = pendingOrdersData.Deliveries.length;

    return count;
  }, [pendingOrdersData]);
  const OrderList = () => {
    return <div className={classes.pt40}>
      {pendingOrdersData.Deliveries.map((item: any) => (
        <OrderItem key={item.Id} data={item} onClick={props.onClick} source={IOrderItemSource.Open} />
      ))}
    </div>
  };
  if (!pendingOrdersData) {
    return <CircularProggressIndicator />;
  }

  return (
    <InfiniteScroll
      style={{ overflow: "hidden" }}
      dataLength={getDataLength()}
      next={props.loadMoreData}
      hasMore={getDataLength() < pendingOrdersData.TotalCount}
      scrollThreshold={0.99}
      loader={<LoadMoreIndicator />}
    >
      <Container className={classes.component}>
        {pendingOrdersLoading && getDataLength() === 0 ? (
          <CircularProggressIndicator />
        ) : getDataLength() === 0 ? (
          <NoResultsFound
            query={props.query}
            filterApplied={props.filterApplied}
          />
        ) : (
          <OrderList />
        )}
      </Container>
    </InfiniteScroll>
  );
};
const useStyles = makeStyles({
  component: {
    display: "flex",
    flexDirection: "column",
    paddingLeft: 0,
    paddingRight: 0,
  },
  noRecordsFound: {
    display: "flex",
    paddingLeft: "24px",
    flexDirection: "column",
  },
  noSearchResults: {
    display: "flex",
    paddingLeft: 24,
    paddingTop: 40,
    flexDirection: "column",
  },
  pt40: {
    paddingTop: 40,
  },
});
